import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeyboardArrowBigDown = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 24.227l-3.28-3.28c-0.52-0.52-1.36-0.52-1.88 0s-0.52 1.36 0 1.88l4.227 4.24c0.52 0.52 1.36 0.52 1.88 0l4.227-4.227c0.52-0.52 0.52-1.36 0-1.88s-1.36-0.52-1.88 0l-3.293 3.267z" })
});
export default SvgKeyboardArrowBigDown;
